import React from 'react';
import GenericCrudPage from '../components/GenericCrudPage';

// Estimates / Patient quotes
export const EstimatesPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="estimates"
    title="Treatment Estimates"
    fields={[
      { key: 'patientName', label: 'Patient Name', required: true },
      { key: 'treatmentName', label: 'Treatment', required: true },
      { key: 'amount', label: 'Amount', type: 'number', required: true },
      { key: 'validTill', label: 'Valid Till', type: 'date' },
      { key: 'notes', label: 'Notes', type: 'textarea' },
      { key: 'status', label: 'Status', type: 'select', options: ['draft', 'sent', 'accepted', 'rejected', 'expired'], default: 'draft' },
    ]}
    listColumns={['patientName', 'treatmentName', 'amount', 'validTill', 'status']}
  />
);

// Patient Ledger
export const LedgerPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="ledger"
    title="Patient Ledger"
    fields={[
      { key: 'patientName', label: 'Patient Name', required: true },
      { key: 'date', label: 'Date', type: 'date', required: true },
      { key: 'description', label: 'Description', required: true },
      { key: 'debit', label: 'Debit', type: 'number', default: 0 },
      { key: 'credit', label: 'Credit', type: 'number', default: 0 },
      { key: 'balance', label: 'Balance', type: 'number' },
    ]}
    listColumns={['date', 'patientName', 'description', 'debit', 'credit', 'balance']}
  />
);

// Credit Notes
export const CreditNotesPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="credit-notes"
    title="Credit Notes"
    fields={[
      { key: 'patientName', label: 'Patient Name', required: true },
      { key: 'amount', label: 'Amount', type: 'number', required: true },
      { key: 'reason', label: 'Reason', type: 'textarea', required: true },
      { key: 'date', label: 'Date', type: 'date' },
      { key: 'refBillNo', label: 'Ref Bill No.' },
      { key: 'status', label: 'Status', type: 'select', options: ['draft', 'issued', 'used'], default: 'draft' },
    ]}
    listColumns={['date', 'patientName', 'amount', 'refBillNo', 'status']}
  />
);

// CouponsPage stub removed — `coupons` route uses real CouponManagerPage.

// Recurring Charges (subscription patients, maintenance plans)
export const RecurringChargesPage = ({ API_BASE }) => (
  <GenericCrudPage
    API_BASE={API_BASE}
    endpoint="recurring-charges"
    title="Recurring Charges"
    fields={[
      { key: 'patientName', label: 'Patient Name', required: true },
      { key: 'description', label: 'Description', required: true },
      { key: 'amount', label: 'Amount', type: 'number', required: true },
      { key: 'frequency', label: 'Frequency', type: 'select', options: ['monthly', 'quarterly', 'yearly'], required: true },
      { key: 'nextDate', label: 'Next Charge Date', type: 'date' },
      { key: 'status', label: 'Status', type: 'select', options: ['active', 'paused', 'cancelled'], default: 'active' },
    ]}
    listColumns={['patientName', 'description', 'amount', 'frequency', 'nextDate', 'status']}
  />
);
